import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { BaseOption } from '@/modules/ta/reportstudio/models/element/metadata/BaseOption';
import {
  ReportElementDesignOption,
  ReportElementTextDesignOption,
} from '@/modules/ta/reportstudio/reportstudio.constants';

export class ReportStudioElementMetadata extends BaseModel {
  /**
   * @type {BaseOption}
   */
  base_options;

  /**
   * @type {BaseDesignOption}
   */
  design_options;

  /**
   * @type {boolean}
   */
  set_as_background;

  constructor(model = {}) {
    super();

    this.set_as_background = model.set_as_background ?? false;
    this.base_options = new BaseOption(model.base_options);
    this.design_options = model.design_options ?? {};
  }

  isTextBold() {
    return this.design_options[ReportElementTextDesignOption.TEXT_BOLD];
  }

  isTextItalic() {
    return this.design_options[ReportElementTextDesignOption.TEXT_ITALIC];
  }

  isTextUnderline() {
    return this.design_options[ReportElementTextDesignOption.TEXT_UNDERLINE];
  }

  isTextStrikeThrough() {
    return this.design_options[ReportElementTextDesignOption.TEXT_STRIKETHROUGH];
  }

  isTextLeftAligned() {
    return (
      this.design_options[ReportElementTextDesignOption.TEXT_ALIGNMENT] ===
      ReportElementDesignOption.TEXT_ALIGNMENT.LEFT
    );
  }

  isTextCenterAligned() {
    return (
      this.design_options[ReportElementTextDesignOption.TEXT_ALIGNMENT] ===
      ReportElementDesignOption.TEXT_ALIGNMENT.CENTER
    );
  }

  isTextJustifyAligned() {
    return (
      this.design_options[ReportElementTextDesignOption.TEXT_ALIGNMENT] ===
      ReportElementDesignOption.TEXT_ALIGNMENT.JUSTIFY
    );
  }

  isTextRightAligned() {
    return (
      this.design_options[ReportElementTextDesignOption.TEXT_ALIGNMENT] ===
      ReportElementDesignOption.TEXT_ALIGNMENT.RIGHT
    );
  }
}
